document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;
        this._onCartUpdate = (event) => {
          if (!this.itemsRoot.isConnected) return;
          ThemeCart.renderEvent(event, async (snapshot) => {
            await Alpine.morph(this.itemsRoot, snapshot.items.outerHTML);
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
            const cartStatus = document.getElementById('cart-live-region-text');
            if (cartStatus && snapshot.region) {
              cartStatus.textContent = snapshot.region;
              cartStatus.setAttribute('aria-hidden', 'false');
            }
            const originalTarget = event.detail.originalTarget;
            if (originalTarget && !this.itemsRoot.contains(originalTarget)) {
              this.$nextTick(() => {
                const dialog = this.itemsRoot.closest('[role="dialog"]');
                this.$focus.within(dialog ? dialog.parentNode : this.itemsRoot).first();
              });
            }
          }, 'items');
        };
        window.addEventListener('shapes:modalcart:afteradditem', this._onCartUpdate);
        window.addEventListener('shapes:modalcart:cartqtychange', this._onCartUpdate);
      },
      destroy() {
        window.removeEventListener('shapes:modalcart:afteradditem', this._onCartUpdate);
        window.removeEventListener('shapes:modalcart:cartqtychange', this._onCartUpdate);
      },
      async itemQuantityChange(key, value) {
        if (this.locked) return;
        const inputEl = this.$el;
        const lineItemEl = inputEl.closest('li[data-cart-item-key]');
        if (!lineItemEl) return;
        const id = key || lineItemEl.getAttribute('data-cart-item-key');
        const rawQuantity = value !== undefined ? value : inputEl.value;
        const quantity = Number(rawQuantity);
        const lastValue = Number(inputEl.dataset.lastValue);
        if (String(rawQuantity).trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
          inputEl.value = lastValue;
          return;
        }
        if (quantity === lastValue) return;
        const config = fetchConfigDefaults();
        config.body = JSON.stringify({
          id, quantity, sections: ThemeCart.sections,
          sections_url: window.location.pathname,
        });
        this.locked = lineItemEl;
        lineItemEl.classList.add('opacity-50', 'cursor-progress');
        try {
          const data = await ThemeCart.mutate(theme.routes.cart_change_url, config,
            'shapes:modalcart:cartqtychange', { originalTarget: lineItemEl });
          const returnedItem = Array.isArray(data.items) && data.items.find((item) => item.key === id);
          if (returnedItem && returnedItem.quantity !== quantity) {
            const currentLine = Array.from(this.itemsRoot.querySelectorAll('[data-cart-item-key]'))
              .find((el) => el.getAttribute('data-cart-item-key') === id);
            const errorEl = currentLine && currentLine.querySelector('[data-cart-quantity-error]');
            if (errorEl) {
              errorEl.textContent = theme.strings.cartAddError.replace('{{ title }}', errorEl.dataset.itemTitle);
              errorEl.classList.remove('hidden');
            }
          }
        } catch (error) {
          if (error.cartRecovering) return;
          inputEl.value = lastValue;
          const errorEl = document.getElementById('cart-errors');
          const message = ThemeCart.errorMessage(error);
          if (errorEl) errorEl.textContent = message;
          liveRegion(message);
        } finally {
          lineItemEl.classList.remove('opacity-50', 'cursor-progress');
          this.locked = null;
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        if (this.locked) return;
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
